import React, { Component } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

import "./MapView.css";
import { Subscribe } from "unstated";
import StateContainer from "../../state/StateContainer";

const MyMapComponent = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      defaultZoom={props.defaultZoom}
      defaultCenter={{ lat: props.defaultCenter.lat, lng: props.defaultCenter.lng }}
    >
      {props.isMarkerShown && (
        <Marker
          defaultClickable={false}
          icon={{ url: props.defaultIcon === "" ? undefined : props.defaultIcon }}
          position={{
            lat: props.defaultCenter.lat,
            lng: props.defaultCenter.lng
          }}
        />
      )}
    </GoogleMap>
  ))
);

class MapView extends Component {
  state = {
    apiKey: "AIzaSyD--kZtlqYEr6YhyBo0HPYXrwDhiSSrV6A"
  }
  render() {
    return (
      <Subscribe to={[StateContainer]}>
        {(state2) => (
          <div className="map-container">
            <button
              className="exit-button"
              onClick={() => state2.toggleMapOff()}
            ></button>
            {
              state2.state.googleMapView.defaultZoom !== undefined ?

                <MyMapComponent
                  defaultZoom={state2.state.googleMapView.defaultZoom}
                  defaultCenter={{ lat: state2.state.googleMapView.latitude, lng: state2.state.googleMapView.longitude }}
                  defaultIcon={state2.state.googleMapView.pinIconUrl}
                  isMarkerShown={true}
                  googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${this.state.apiKey}&libraries=geometry,drawing,places`}
                  loadingElement={<div style={{ height: `90%` }} />}
                  containerElement={<div style={{ height: `90%` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />
                :
                null
            }
          </div>
        )}
      </Subscribe>
    );
  }
}

export default MapView;
